import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Session } from '@models/session';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AutomatedAttendanceOptionsComponent } from '../automated-attendance-options/automated-attendance-options.component';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-verify-ready',
  styleUrls: ['verify-ready.component.scss'],
  templateUrl: 'verify-ready.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, AutomatedAttendanceOptionsComponent, IconDirective]
})
export class VerifyReadyComponent {
  @Input() session: Session;
  @Output() next = new EventEmitter();

  get agentOrNone(): string {
    return this.session.liveAgent ? 'agent' : 'no-agent';
  }

  get displayAutomatedAttendanceOptions(): boolean {
    const serviceEnabled = this.session.services.includes('automated_attendance');
    const optionsEnabled = this.session.serviceOptions.automatedAttendance.anythingEnabled;
    return serviceEnabled && optionsEnabled;
  }

  done() {
    this.next.emit();
  }
}
